import { Pipe, PipeTransform } from '@angular/core';
import { Property } from '@ui/shared/model';
import { canViewPropertyApplicants } from '../../utils/properties';

@Pipe({
  name: 'canViewApplicantsPipe'
})
export class CanViewApplicantsPipePipe implements PipeTransform {
  transform(property: Property): boolean {
    return canViewPropertyApplicants(property);
  }
}
